@if (label) {
  <i
    [tooltip]="label | translate"
    [class.myre-icon-help]="icon === 'myre-icon-help' || !icon"
    [class.myre-icon-info]="icon === 'myre-icon-info'"
  ></i>
}
